// import { useContext } from 'react';

// import { UserContext } from '../../contexts/user.context';

import { Button } from 'antd';
import { signInWithGooglePopup, createUserDocumentFromAuth } from '../../utils/firebase.utils';


import { 
	SignInContainer
 } from "./signin.styles";

const SignIn = () => {
    // const { setCurrentUser } = useContext(UserContext);

    const logGoogleUser = async () => {
        const {user} = await signInWithGooglePopup();

        // setCurrentUser(user);
    
        const userDocRef = await createUserDocumentFromAuth(user)
        // console.log(response);
    }

	return(
		<SignInContainer>
            <Button onClick={logGoogleUser}>Sign In</Button>
		</SignInContainer>
	);
}

export default SignIn;